import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'
import {
  dateInEpochTimeResolver,
  dateResolver,
  fullDateTimeResolver,
  timestampResolver
} from './time'

const streamDataFieldResolvers: FieldResolver[] = [
  dateInEpochTimeResolver,
  dateResolver,
  fullDateTimeResolver,
  timestampResolver
]

const timeRelatedFieldsResolver: FieldResolver = (metadata: Metadata) => {
  let result = {} as StreamData
  streamDataFieldResolvers.forEach((resolver) => {
    result = { ...result, ...resolver(metadata) }
  })

  return result
}

export default timeRelatedFieldsResolver
